import React from "react";
import {
  View,
  Text,
  StyleSheet,
  Image,
  TouchableOpacity,
  ImageSourcePropType,
  ImageBackground,
} from "react-native";
import { useTranslation } from "react-i18next";
import {
  BuyBtn,
  buyNowChips,
  buyNowPink,
  ChipsBackgrOne,
} from "../../../../assets";
import { Package } from "../../../../store/types";

type ChipCardDesktopProps = {
  vipIcon: ImageSourcePropType;
  borderColor: string;
  textColor: string;
  vipLabel: ImageSourcePropType;
  chipBackground: ImageSourcePropType;
  amount: number;
  price: number;
  pkg: Package;
  onPayment: (packageItem: Package) => void;
};

const ChipCardDesktop = ({
  vipIcon,
  textColor,
  vipLabel,
  amount,
  price,
  pkg,
  onPayment,
}: ChipCardDesktopProps) => {
  const { t } = useTranslation();
  const handleBuyPress = () => {
    onPayment(pkg);
  };
  
  return (
    <ImageBackground
      source={ChipsBackgrOne}
      resizeMode="stretch"
      style={styles.background}
    >
      <View style={styles.card}>
        <View style={styles.labelRow}>
          <Image
            source={vipLabel}
            style={styles.chipLabel}
            resizeMode="contain"
          />
          <Text
            style={[styles.amount, { color: textColor }]}
            numberOfLines={1}
            adjustsFontSizeToFit
          >
            {amount}
          </Text>
        </View>
        
        <View style={styles.top}>
          <Image
            source={vipIcon}
            style={styles.chipImage}
            resizeMode="contain"
          />
        </View>

        <View style={styles.bottom}>
          <Text style={styles.price}>{price}€</Text>

          <TouchableOpacity
            style={styles.buyNowButton}
            onPress={handleBuyPress}
          >
            <ImageBackground
              source={buyNowChips}
              style={styles.buyNowBtn}
              resizeMode="contain"
            >
              <Text style={styles.text}>{t("T_SITE_HEADER_BUY")}</Text>
            </ImageBackground>
          </TouchableOpacity>
        </View>
      </View>
    </ImageBackground>
  );
};

export default ChipCardDesktop;

const styles = StyleSheet.create({
  background: {
    width: "100%",
    aspectRatio: 0.8,
    paddingVertical: 15,
    paddingHorizontal: 12,
  },
  card: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  top: {
    flex: 1.2, // ✅ Increased from 1 to give more space to image
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
  },
  bottom: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: 8,
  },
  chipImage: {
    width: "100%",
    height: "100%",
    maxHeight: 140, 
  },
  labelRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 7,
    paddingHorizontal: 4,
  },
  chipLabel: {
    width: 20,
    height: 20,
    marginRight: 4,
    flexShrink: 0,
  },
  amount: {
    fontSize: 20,
    fontWeight: "900",
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
    letterSpacing: 0.5,
    flexShrink: 1,
  },
  price: {
    fontSize: 20,
    fontWeight: "600",
    color: "#fff",
    textAlign: "center",
    marginBottom: 10,
    textShadowColor: "#000",
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
    letterSpacing: 0.8,
  },
  buyNowButton: {
    alignItems: "center",
    justifyContent: "center",
  
  },
   buyNowBtn: {
    width: 150, 
    height: 40, 
  },
  text: {
    fontSize: 16, 
    fontWeight: "700",
    letterSpacing: 0.8, 
    color: "#E0E0E0",
    textShadowColor: "rgba(0, 0, 0, 0.6)",
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 2,
    textTransform: "uppercase",
    textAlign: "center",
    paddingTop: 5, 
  },
});